import React, { useState } from "react";
import Button from "../../common/Button";

export default function LowStockWidget() {
    const [items, setItems] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState("");

    const handleAddItem = (e: React.FormEvent) => {
        e.preventDefault();
        if (inputValue.trim()) {
            setItems([...items, inputValue.trim()]);
            setInputValue("");
        }
    };

    const handleRemoveItem = (index: number) => {
        setItems(items.filter((_, i) => i !== index));
    };

    return (
        <div className="mod-card" style={{ minHeight: '300px', display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '16px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fef2f2', borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}>
                <h3 style={{ margin: 0, fontSize: '1.05rem', color: '#991b1b' }}>⚠️ Low Stock Alerts</h3>
                <span style={{ fontSize: '0.8rem', background: '#ef4444', color: 'white', padding: '2px 8px', borderRadius: '12px', fontWeight: 600 }}>{items.length} Items</span>
            </div>
            
            <div style={{ padding: '16px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                <form onSubmit={handleAddItem} style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                    <input
                        type="text"
                        placeholder="Add item name..."
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        style={{ flex: 1, padding: '10px 14px', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '0.9rem', outline: 'none' }}
                    />
                    <Button variant="primary" type="submit" disabled={!inputValue.trim()}>Add</Button>
                </form>
                
                <div style={{ flex: 1, overflowY: 'auto' }}>
                    {items.length === 0 ? (
                        <div style={{ textAlign: 'center', color: '#94a3b8', padding: '20px', border: '1px dashed #cbd5e1', borderRadius: '8px' }}>
                            No low stock items reported.
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            {items.map((item, index) => (
                                <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8fafc', padding: '10px 14px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                    <span style={{ color: '#334155', fontWeight: 500, fontSize: '0.95rem' }}>{item}</span>
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveItem(index)}
                                        title="Mark as Restocked"
                                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 0.7, transition: 'opacity 0.2s' }}
                                        onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                                        onMouseLeave={(e) => e.currentTarget.style.opacity = '0.7'}
                                    >
                                        ✅
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
